import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import utilityfunctions from '../../../util/utilityfunctions';

const EmptyMessage = (props) => {
	const {title, subTitle} = props;

	const titleText = utilityfunctions.removeTags(title);
	const subTitleText = utilityfunctions.removeTags(subTitle);

	return (
		<StyledEmptyMessage className="empty-message">
			<p title={titleText}>
				<b>{utilityfunctions.createRichTextElement(title)}</b>
			</p>
			{subTitle && <p title={subTitleText}>{utilityfunctions.createRichTextElement(subTitle)}</p>}
		</StyledEmptyMessage>
	);
};

export default EmptyMessage;

EmptyMessage.defaultProps = {
	title: '',
	subTitle: ''
};

EmptyMessage.propTypes = {
	title: PropTypes.string,
	subTitle: PropTypes.string
};

const StyledEmptyMessage = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	margin-top: -3rem;
	padding: 8rem 0;
	p {
		color: ${(props) => props.theme.color[`grey400`]};
		margin-bottom: 0.5rem;
		font-size: 1.2rem;
	}
`;
